import { ResolvedPhase } from 'modules/Cube/domain/cube.domain.types'

/**
 * Whether any phase in the set carries an alignment warning - the same thing
 * the editor's "Align dates" warning is driven by. A warning means a phase ends
 * part way through a billing period and the phase after it changes a price,
 * discount or minimum, which our proration can't bill correctly.
 *
 * The editor's own warning is read off the align-dates availability, but that
 * is hidden once the quote is past editing, so an executing quote has to look
 * at the analysis directly.
 */
export const hasPhaseAlignmentWarnings = (
  orderedPhases: ResolvedPhase[]
): boolean =>
  orderedPhases.some(phase =>
    Object.values(phase.analysis?.proration ?? {}).some(
      invalidEntities => invalidEntities.length > 0
    )
  )
